/**
 * Matter Types Service - React Query Hooks
 */

'use client';

import { useQuery } from '@tanstack/react-query';
import { directApiClient } from '@/lib/api/direct-client';
import type { MatterType } from './types';

/**
 * Query key for matter types
 */
export const matterTypesQueryKey = ['matter-types', 'all'] as const;

/**
 * Hook to fetch all available matter types
 * Returns array of { label, slug } objects
 */
export function useMatterTypes() {
  return useQuery({
    queryKey: matterTypesQueryKey,
    queryFn: async () => {
      // Fetch from API
      const response = await directApiClient.get<MatterType[]>('/matter-types');
      return response;
    },
    // Matter types are relatively static, cache for longer
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000 // 30 minutes (formerly cacheTime)
  });
}
